import React, { Component } from 'react';
import animations from './animations';
import Heading from "../../elements/Heading";
import { Link } from 'react-router-dom';

class ThreeColumnIcons extends Component {

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props && this.props.dataReceived) {
            this.controller = animations.initialise(this);
        }
    }

    componentWillUnmount() {
        animations.destroy(this.controller);
    }
    
    render() {
        let Items;
        if (this.props.data.items && !this.props.isCaseStudy) {
            Items = this.props.data.items.map((item, key) => {
                return (
                    <div key={key} className="item">
                        { (item.image ? <img src={item.image} height="60" alt={item.title} /> : '') }
                        <h3 dangerouslySetInnerHTML={{__html: item.title}} />
                        <p dangerouslySetInnerHTML={{__html: item.description}} />
                    </div>

                );
            });
        } 

        if (this.props.data.items && this.props.isCaseStudy) {
            Items = this.props.data.items.map((item, key) => {
                return (
                    <div key={key} className="item">
                        { (item.image ? <img src={item.image} height="60" alt={item.title} /> : '') }
                        <p className="font-xsmall" dangerouslySetInnerHTML={{__html: item.description}} />
                        <h3 className="font-large" dangerouslySetInnerHTML={{ __html: item.title }} />
                        {item.url && <Link to={`/case-studies/${item.url}`} className="font-medium color-lime">Read More</Link>}
                    </div>

                );
            });
        }

        return (
            <section className="three-column-icons">
                <div className="inner">
                    <div className="row">
                        <div className="col-md-6 col-md-offset-3 centered">
                            <Heading title={this.props.data.title} subTitle={this.props.data.subTitle} />
                            { (this.props.data.description !== '' ? <p dangerouslySetInnerHTML={{__html: this.props.data.description}} /> : '') }
                        </div>
                        <div className="col-md-10 col-md-offset-1 centered">
                            <div className={`${this.props.isCaseStudy ? 'items case-study-items' : 'items'}`}>
                                {Items}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bottom-wave-darkgreen" />
            </section>
        );
    }
    
}

export default ThreeColumnIcons;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/ThreeColumnIcons/ThreeColumnIcons.js